import { createContext } from "react"

export const CartContext = createContext({
  cart: {
    products: [],
    userData: {},
  },
  setCart: () => null,
})
export const ViewCart = createContext(false)
export const Theme = createContext("dark")
export const SetTheme = createContext()
